import { mapActions } from "vuex";

export default  {
	created () {    
	   this.updateDataPost({ 
		   data: { 
			   data: [],
			   route: 'save_factura', 
			   tablaPost: ['facturacions','diagnosticos']
			}
		}) 
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'garantiaOrdenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'garantia_orden', 
									tablaPost: ['garantia_diagnosticos','garantia_orden','info_garantia']
								 }
							 }) 
						break;
						case 'anularExamenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'anular_examen', 
									tablaPost: ['info_examens']
								 }
							 }) 
						break;

					}
				}

				let data_backend= await this.save(event.save)

				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'garantiaOrdenFtn':
							this.spliceDataGet(this.indexData)
							window.open(this.url+"/api/pdf/garantia_orden_venta?id="+data_backend['ids']['id_info_garantia']+"&token="+this.token, "_blank");						
							window.open(this.url+"/api/pdf/garantia_diagnosticos?id="+data_backend['ids']['id_info_garantia']+"&token="+this.token, "_blank");						
						break;
						case 'anularExamenFtn':
							this.spliceDataGet(this.indexData)							
						break;
					}
				}

				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
